import { Component, computed, input } from "@angular/core";
import { ExtendedGenericSystem } from "src/typings/extended-generic-system";
import {
  Boiler,
  BoilerControl,
  BoilerControlWithFitsIn,
  ControlSystem,
} from "../../../../../codegen/out/types";

@Component({
  selector: "app-system-info",
  templateUrl: "./system-info.component.html",
  styleUrls: ["./system-info.component.scss"],
  standalone: false,
})
export class SystemInfoComponent {
  system = input<ExtendedGenericSystem>();

  verboseNames = computed(() => {
    if (this.system().verboseNames.length === 0) {
      return "-";
    }
    return this.system().verboseNames.join(", ");
  });
  systemImageUrl = computed(() => {
    if (this.system().thumbnail.realLife !== null) {
      return this.system().thumbnail.realLife.url;
    } else {
      return this.system().thumbnail.schematic?.url;
    }
  });
  systemTypeImageUrl = computed(
    () => `assets/systemTypes/${this.system().__typename}.png`
  );
  heatingTypeInfoAvailable = computed(() => {
    return [
      "EffectiveBoilerControl",
      "BoilerControlWithFitsIn",
      "BoilerControl",
    ].includes(this.system().__typename);
  });
  heatingType = computed(() => {
    if (this.heatingTypeInfoAvailable()) {
      return (this.system() as BoilerControl).heatingType;
    }
  });
  heatPumpType = computed(() => {
    if (this.heatingTypeInfoAvailable()) {
      return (this.system() as BoilerControl).heatPumpType ?? "-";
    }
  });
  powerSupply = computed(() => {
    switch (this.system().__typename) {
      case "AuxiliaryControl":
      case "Boiler":
      case "BoilerControl":
      case "BoilerControlWithFitsIn":
      case "ControlBoard":
      case "EffectiveBoilerControl":
      case "Furnace":
      case "Remote":
      case "RfRemote":
      case "RfRoomThermostat":
      case "RoomThermostat":
      case "RoomThermostatReceiver":
      case "TranslationModule":
        return (this.system() as ControlSystem).powerSupply?.join(",");
    }
  });
  fitInAvailability = computed(() => {
    if (this.system().__typename === "BoilerControl") {
      return (this.system() as BoilerControl).fitInAvailability;
    }
  });
  boilerSystem = computed(() => {
    if (this.system().__typename === "Boiler") {
      return this.system() as Boiler;
    }
  });
  boilerControlWithFitsInSystem = computed(() => {
    if (this.system().__typename === "BoilerControlWithFitsIn") {
      return this.system() as BoilerControlWithFitsIn;
    }
  });

  openSystemImage(): void {
    window.open(this.systemImageUrl(), "_blank");
  }
}
